import qs from "qs";
import { useSdkContext } from "scmp-sdk/components/contexts";

import type { SocialType } from "./enums";
import type { SignUpQueryStringPayload } from "./types";

export const useSocialLogin = () => {
  const { config } = useSdkContext();

  const getSocialLoginUrl = (
    socialType: SocialType,
    parameters: SignUpQueryStringPayload,
    isAgreed: boolean,
  ) => {
    const accountUrl = new URL(config.accounts.host);
    const destinationUrl = new URL(location.href);
    destinationUrl.search = qs.stringify(parameters); // Use qs at here for better parsing in app side

    const { ...restParameters } = parameters;

    const signinUrl = new URL(location.href);
    signinUrl.search = qs.stringify(restParameters);

    accountUrl.searchParams.set("callback", signinUrl.toString());
    accountUrl.searchParams.set("destination", destinationUrl.toString());
    accountUrl.searchParams.set("nonce", "");
    accountUrl.searchParams.set("optIn", isAgreed ? "true" : "false");
    accountUrl.searchParams.set("triggerPoint", parameters.triggerPoint);
    accountUrl.searchParams.set("newsletterName", parameters.newsletterName);
    accountUrl.searchParams.set("packageName", parameters.packageName ?? "");

    accountUrl.pathname = `/login/${socialType}`;
    return accountUrl.toString();
  };

  return {
    getSocialLoginUrl,
  };
};
